import React, { Component } from 'react';
import Select from 'react-select';
import Swal from "sweetalert2/dist/sweetalert2.js";

class ExportForm extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            selectedTenant: null,
            selectedCategory: null,
            categories: [],
            categoriesLoaded: false,
            preview: null,
            previewLoaded: false,
            isExporting: false
        }
    }

    handleTenantChange = (selectedOption) => {
        this.setState({
            selectedTenant: selectedOption,
            selectedCategory: null,
            categories: [],
            categoriesLoaded: false,
            preview: null
        }, () => {
            if (selectedOption) {
                this.loadCategories(selectedOption.value);
            }
        });
    }

    handleCategoryChange = (selectedOption) => {
        this.setState({
            selectedCategory: selectedOption,
            preview: null,
            previewLoaded: false
        }, () => {
            if (selectedOption) {
                this.loadPreview(selectedOption.value);
            }
        });
    }

    loadCategories = (tenantId) => {
        fetch(`/formatos/module_transfers/format_categories/${tenantId}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            const options = (data.format_categories || []).map(cat => ({
                value: cat.id,
                label: cat.name
            }));
            this.setState({
                categories: options,
                categoriesLoaded: true
            });
        });
    }

    loadPreview = (categoryId) => {
        this.setState({ previewLoaded: false });
        fetch(`/formatos/module_transfers/export_preview/${categoryId}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                preview: data.preview,
                previewLoaded: true
            });
        });
    }

    handleExport = () => {
        if (!this.state.selectedCategory) {
            Swal.fire({
                icon: 'warning',
                title: 'Seleccione un modulo',
                text: 'Debe seleccionar una empresa y un modulo para exportar'
            });
            return;
        }

        this.setState({ isExporting: true });

        fetch(`/formatos/module_transfers/export`, {
            method: 'POST',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                format_category_id: this.state.selectedCategory.value
            })
        })
        .then(response => response.json())
        .then(data => {
            this.setState({ isExporting: false });

            if (data.success) {
                // Download the JSON file
                const blob = new Blob([JSON.stringify(data.data, null, 2)], { type: 'application/json' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = data.filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                Swal.fire({
                    icon: 'success',
                    title: 'Exportacion exitosa',
                    text: `El modulo se ha exportado correctamente como ${data.filename}`
                });

                this.props.loadHistory();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al exportar',
                    text: data.error || 'Ocurrio un error durante la exportacion'
                });
            }
        })
        .catch(error => {
            this.setState({ isExporting: false });
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error de conexion al exportar'
            });
        });
    }

    render() {
        const tenantOptions = this.props.tenants.map(t => ({
            value: t.id,
            label: t.name
        }));

        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">
                                <i className="fas fa-download mr-2"></i>
                                Exportar Modulo
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label>Empresa (Origen)</label>
                                <Select
                                    value={this.state.selectedTenant}
                                    onChange={this.handleTenantChange}
                                    options={tenantOptions}
                                    placeholder="Seleccione una empresa..."
                                    isClearable
                                />
                            </div>

                            <div className="form-group">
                                <label>Modulo a Exportar</label>
                                <Select
                                    value={this.state.selectedCategory}
                                    onChange={this.handleCategoryChange}
                                    options={this.state.categories}
                                    placeholder={this.state.selectedTenant ? "Seleccione un modulo..." : "Primero seleccione una empresa"}
                                    isDisabled={!this.state.selectedTenant}
                                    isClearable
                                />
                            </div>

                            <button
                                className="btn btn-primary btn-block mt-4"
                                onClick={this.handleExport}
                                disabled={!this.state.selectedCategory || this.state.isExporting}
                            >
                                {this.state.isExporting ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                        Exportando...
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-download mr-2"></i>
                                        Descargar JSON
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">
                                <i className="fas fa-eye mr-2"></i>
                                Vista Previa
                            </h5>
                        </div>
                        <div className="card-body">
                            {this.state.preview ? (
                                <div>
                                    <h6 className="mb-3">
                                        <strong>{this.state.preview.category.name}</strong>
                                    </h6>
                                    {this.state.preview.category.description && (
                                        <p className="text-muted">{this.state.preview.category.description}</p>
                                    )}

                                    <hr />

                                    <div className="row text-center mb-3">
                                        <div className="col-4">
                                            <div className="h4 mb-0 text-primary">
                                                {this.state.preview.statistics.total_formats}
                                            </div>
                                            <small className="text-muted">Formatos</small>
                                        </div>
                                        <div className="col-4">
                                            <div className="h4 mb-0 text-info">
                                                {this.state.preview.statistics.subcategories}
                                            </div>
                                            <small className="text-muted">Subcategorias</small>
                                        </div>
                                        <div className="col-4">
                                            <div className="h4 mb-0 text-success">
                                                {this.state.preview.formats.reduce((acc, f) => acc + f.questions_count, 0)}
                                            </div>
                                            <small className="text-muted">Preguntas</small>
                                        </div>
                                    </div>

                                    <hr />

                                    {this.state.preview.formats.length > 0 && (
                                        <div>
                                            <h6>Formatos principales:</h6>
                                            <ul className="list-group list-group-flush">
                                                {this.state.preview.formats.slice(0, 5).map((format, idx) => (
                                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center px-0">
                                                        {format.name}
                                                        <span className="badge badge-primary badge-pill">
                                                            {format.questions_count} preg.
                                                        </span>
                                                    </li>
                                                ))}
                                                {this.state.preview.formats.length > 5 && (
                                                    <li className="list-group-item text-muted px-0">
                                                        ... y {this.state.preview.formats.length - 5} formatos mas
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    )}

                                    {this.state.preview.subcategories.length > 0 && (
                                        <div className="mt-3">
                                            <h6>Subcategorias:</h6>
                                            <ul className="list-group list-group-flush">
                                                {this.state.preview.subcategories.slice(0, 5).map((sub, idx) => (
                                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center px-0">
                                                        {sub.name}
                                                        <span className="badge badge-info badge-pill">
                                                            {sub.formats_count} form.
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="text-center text-muted py-5">
                                    <i className="fas fa-folder-open fa-3x mb-3"></i>
                                    <p>Seleccione un modulo para ver la vista previa</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExportForm;
